import { useLang } from '../store.mjs'
import data from './data.mjs'
import { LOCALES, DEFAULT_LOCALE, getLocale, localeDisplay } from './locales.mjs'

export { LOCALES, DEFAULT_LOCALE, getLocale, localeDisplay, isChineseLocale, intlLocaleFor } from './locales.mjs'

function build(columnIndex) {
  const map = {}
  data.forEach((row) => {
    const key = row[0]
    if (!key) return
    const val = row[columnIndex]
    map[key] = val != null && val !== '' ? val : (columnIndex === 0 ? key : row[1] ?? key)
  })
  return map
}

const langs = Object.fromEntries(
  LOCALES.map(({ id, column }) => [id, build(column)])
)

const [lang] = useLang()

export const t = (msg) => {
  const table = langs[lang.value] || langs[DEFAULT_LOCALE]
  if (table?.[msg]) return table[msg]
  return langs[DEFAULT_LOCALE]?.[msg] ?? msg
}

/** 在文案中替换 `{key}` 占位符（与 data.mjs 中文 key 配套使用） */
export const tf = (templateKey, params = {}) => {
  let s = t(templateKey)
  if (!params || typeof params !== 'object') return s
  for (const [k, val] of Object.entries(params)) {
    const needle = `{${k}}`
    s = s.split(needle).join(String(val))
  }
  return s
}